import { FC, useCallback, useEffect, useRef } from "react";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { toggleDashboardCollapsed } from "../../../redux/slices/consolePageSlice";
import HideShowButton from "../../presenters/_shared/HideShowButton";
import { useSelector } from "react-redux";
import { selectAuth } from "../../../redux/slices/authSlice";

interface IProps {}

const closeAPDFuncName = "closeAPD";

const RootContainer = styled.div<{ isDashboardPanelOpen: boolean }>`
  width: 100%;
  overflow: hidden;
  ${(props) =>
    props.isDashboardPanelOpen ? "height: 100%;" : "max-height: 100%;"}
  filter: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
`;

const DashboardContainer = styled.div<{ isDashboardPanelOpen: boolean }>`
  height: 100%;
  display: ${(props) => (props.isDashboardPanelOpen ? "block" : "none")};
`;

const ButtonContainer = styled.div`
  width: 1.5rem;
  height: 2rem;
`;

const PerformanceDashboardContainer: FC<IProps> = () => {
  const dispatch = useAppDispatch();
  const fragmentRef = useRef<HTMLDivElement>(null);

  const isDashboardPanelOpen = useAppSelector(
    (state) => state.consolePageState.isDashboardPanelOpen
  );

  const { token } = useSelector(selectAuth);

  useEffect(() => {
    const fragment = fragmentRef.current;
    fragment?.addEventListener(closeAPDFuncName, () => {
      dispatch(toggleDashboardCollapsed(!isDashboardPanelOpen));
      localStorage.removeItem("isAPDVisible");
    });
    return () => {
      fragment?.removeEventListener(closeAPDFuncName, () => {
        dispatch(toggleDashboardCollapsed(!isDashboardPanelOpen));
        localStorage.removeItem("isAPDVisible");
      });
    };
  }, [dispatch, fragmentRef, isDashboardPanelOpen]);

  const toggleDashboard = useCallback(() => {
    dispatch(toggleDashboardCollapsed(!isDashboardPanelOpen));
    localStorage.setItem("isAPDVisible", "true");
  }, [dispatch, isDashboardPanelOpen]);

  return (
    <RootContainer isDashboardPanelOpen={isDashboardPanelOpen}>
      <DashboardContainer isDashboardPanelOpen={isDashboardPanelOpen}>
        <agent-performance-dashboard-fragment
          ref={fragmentRef}
          token={token}
          showCloseButton={true}
        />
      </DashboardContainer>
      {!isDashboardPanelOpen && (
        <ButtonContainer>
          <HideShowButton id="performance_dashboard_toggle_btn" eventHandler={toggleDashboard} direction="left" />
        </ButtonContainer>
      )}
    </RootContainer>
  );
};
export default PerformanceDashboardContainer;
